import { COUNTRIES_BY_CODE } from "@redotech/locale/countries";
import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  customerAddressFromModel,
  validateCustomerAddressCondition,
  type CustomerAddressState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const CUSTOMER_ADDRESS = (
  Details: React.ComponentType<ConditionTypeDetailsProps<CustomerAddressState>>,
): ConditionType<CustomerAddressState, Condition.CustomerAddress> => ({
  name: CONDITION_NAMES[Condition.CUSTOMER_ADDRESS],
  description(state) {
    if (!state.country) {
      return t("No country selected");
    }
    const countryName = COUNTRIES_BY_CODE[state.country] || state.country;
    const count = state.provinceCodes.length;
    if (state.country === "US") {
      return count === 0
        ? t("{{country}}: No states selected", { country: countryName })
        : t("{{country}}: {{count}} states selected", {
            country: countryName,
            count,
          });
    }
    return count === 0
      ? t("{{country}}: No provinces selected", { country: countryName })
      : t("{{country}}: {{count}} provinces selected", {
          country: countryName,
          count,
        });
  },
  Details(props: ConditionTypeDetailsProps<CustomerAddressState>) {
    return React.createElement(Details, props);
  },
  empty: { country: "", provinceCodes: [] },
  fromModel(model) {
    return customerAddressFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.CUSTOMER_ADDRESS,
      country: state.country,
      provinceCodes: state.provinceCodes,
    };
  },
  valid(state) {
    return validateCustomerAddressCondition(state).valid;
  },
});
